<template>
    <header>
        <h1>{{dataCount}}</h1>
    </header>
</template>

<script>
export default {
  props: ['dataCount', 'currentPage']
}
</script>

<style scope>
h1 {
    font-size: 2.6rem;
    font-family: 'DBstraight12';
    text-align: center;
}

h1::before {
    content: '';
    background-image: url('../assets/img/love.svg');
    background-size: contain;
    background-position-y: top;
    display: inline-block;
    width: 2rem;
    height: 2rem;
    margin-right: 20px;
    vertical-align: baseline;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue